module.exports = __webpack_public_path__ + "static/media/YonderMountainStringBandFallTour2011handdrawn4colorscreenprint.6132b1cd.webp";